module.exports = __webpack_public_path__ + "static/img/ecriture.50b6520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecriture.jpg
// module id = 28
// module chunks = 0